<template>
  <m-bottom fclass="bg-black" />
  <!-- <div class="ftdiv bg-g twhite">
    <div class="htmldiv tdiv pt40 pb10">
      <div class="dinline-block vtop mr40">
        <img src="../../assets/images/index_01_02.png" />
        <div class="txt pl20">
          <div class="tc14 mt20">Contact Us</div>
          <div class="mb5">院办电话：0576-88665038</div>
          <div>招生就业：0576-88665165</div>
          <div class="tc14 mt20">Address</div>
          <div>地址：浙江省台州市学院路788号</div>
        </div>
      </div>
      <div class="dinline-block vtop mr30 pt10">
        <div class="tc14 fbold fs16 mb15">学历教育</div>
        <a href="#" class="twhite dblock mb10">★专业介绍</a>
        <a href="#" class="twhite dblock mb10">★招生信息</a>
        <a href="#" class="twhite dblock mb10">★通知公告</a>
        <a href="#" class="twhite dblock mb10">★政策文件</a>
      </div>

      <div class="dinline-block vtop mr30 pt10">
        <div class="tc14 fbold fs16 mb15">专升本自考</div>
        <a href="#" class="twhite dblock mb10">★主考院校简介</a>
        <a href="#" class="twhite dblock mb10">★专业介绍</a>
        <a href="#" class="twhite dblock mb10">★自考资料</a>
        <a href="#" class="twhite dblock mb10">★通知公告</a>
      </div>
      <div class="dinline-block vtop mr30 pt10">
        <div class="tc14 fbold fs16 mb15">远程教育</div>
        <a href="#" class="twhite dblock mb10">★公告信息</a>
        <a href="#" class="twhite dblock mb10">★走进网院</a>
        <a href="#" class="twhite dblock mb10">★专业介绍</a>
        <a href="#" class="twhite dblock mb10">★招生简章</a>
        <a href="#" class="twhite dblock mb10">★通知公告</a>
        <a href="#" class="twhite dblock mb10">★政策文件</a>
      </div>
      <div class="dinline-block vtop mr30 pt10">
        <div class="tc14 fbold fs16 mb15">专技继续教育</div>

      </div>
      <div class="dinline-block vtop mr30 pt10">
        <div class="tc14 fbold fs16 mb15">培训与技能考证</div>
        <a href="#" class="twhite dblock mb10">★培训项目</a>
        <a href="#" class="twhite dblock mb10">★师资团队</a>
        <a href="#" class="twhite dblock mb10">★培训日历</a>
        <a href="#" class="twhite dblock mb10">★通知公告</a>
        <a href="#" class="twhite dblock mb10">★培训咨询</a>
      </div>
      <div class="wx dinline-block tcenter mr20 pt10">
        <div class="igs pl10 pr10 pt10 pb10 bgw">
          <img src="../../assets/images/index_02.png" alt="" width="135" height="135">
        </div>
        <div class="mt10">官方微信公众号</div>
      </div>
      <div class="wx dinline-block tcenter pt10">
        <div class="igs pl10 pr10 pt10 pb10 bgw">
          <img src="../../assets/images/index_02.png" alt="" width="135" height="135">
        </div>
        <div class="mt10">招生办公众号</div>
      </div>
    </div>
    <div class="cydiv tcenter tc14 pt15 pb15">
      Copyright © 2020版权所有 台州职业技术学院继续教育学院 All rights&nbsp;reserved&nbsp;&nbsp;<a href="#" class="tc14">浙ICP备060******0号</a>
    </div>
  </div> -->
</template>

<script>
    import MBottom from "../index/bottom"
    export default {
        name: "bottom",
        components:{
          MBottom
        }
    }
</script>

<style scoped>
  .ftdiv a{color: #fff;}
  .ftdiv a:hover{text-decoration: underline;}

  .ftdiv.bg-m a{color: #c6d2e1;}
  .ftdiv.bg-m .cydiv a{color: #8e9fc2;}
  .ftdiv.bg-m a:hover,.ftdiv.bg-m .cydiv a:hover{color: #fff;}
  .ftdiv .cydiv{border-top: 1px solid #354987;}

  .ftdiv.bg-g a:hover{color: #bbd9bb;}
  .ftdiv.bg-g .tc14{color: #bbd9bb;}
  .ftdiv.bg-g .cydiv{border-color: #7ca87c;}

  .ftdiv.bg-c .tc14{color: #e8ddcd;}
  .ftdiv.bg-c .cydiv{border-color: #e8ddcd;}
  .ftdiv.bg-c a:hover{color: #e8ddcd;}

  .ftdiv.bg-b .tc14{color: #e5eff8;}
  .ftdiv.bg-b .cydiv{border-color: #5aa4e8;}
  .ftdiv.bg-b a:hover{color: #e5eff8;}
</style>



// WEBPACK FOOTER //
// src/components/zedu/bottom.vue